export default {
  apiUrl: '//pix.wix.com/services/youtube',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/youtube/settings.js